import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { enumDetailedInfoPlacementEnum } from '@app/data-layer/enums/lcl';
import { LclQuoteCardModel } from '@data-layer/models/lcl/lcl-quote-card.model';

@Component({
  selector: 'app-lcl-dashboard-quote-card',
  templateUrl: './lcl-dashboard-quote-card.component.html',
  styleUrls: ['./lcl-dashboard-quote-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LclDashboardQuoteCardComponent implements OnInit {
  @Input() public quote: LclQuoteCardModel;

  public referenceTitleKey: string = 'LABELS.QUOTE_ID';
  public enumDetailedInfoPlacementEnum: typeof enumDetailedInfoPlacementEnum = enumDetailedInfoPlacementEnum;

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

  public ngOnInit(): void {}

  public bookQuote(): void {
    this.router.navigate(['/lcl-shipping', this.quote.id, 'booking'], { relativeTo: this.activatedRoute });
  }
}
